import React, { useState } from 'react'
import { LogoContainer, Card, Selection } from './styles'
import target from '../../images/retail/target.webp'
import costco from '../../images/retail/costco.png'
import bestBuy from '../../images/retail/best-buy.png'
import sams from '../../images/retail/sams.webp'
import amazon from '../../images/retail/amazon.png'
import walmart from '../../images/retail/walmart.webp'

const RetailPartners = () => {
  const [selectedCategory, setSelectedCategory] = useState('Calendar')

  const partners = [
    {
      id: 'target',
      name: `Target`,
      link: 'https://www.target.com/p/skylight-10-digital-photo-frame/-/A-89661638?preselect=89566847#lnk=sametab',
      image: target,
      products: ['Frame'],
    },
    {
      id: 'target',
      name: `Target`,
      link: 'https://www.target.com/p/skylight-15-34-touchscreen-smart-calendar-white/-/A-89566848#lnk=sametab',
      image: target,
      products: ['Calendar'],
    },
    {
      id: 'costco',
      name: `Costco`,
      link: 'https://www.costco.com/CatalogSearch?dept=All&keyword=skylight+calendar',
      image: costco,
      products: ['Calendar'],
    },
    {
      id: 'bestbuy',
      name: `Best Buy`,
      link: 'https://www.bestbuy.com/site/skylight-calendar-15-inch-touchscreen-smart-calendar-and-chore-chart-silver/6576718.p?skuId=6576718',
      image: bestBuy,
      products: ['Calendar'],
    },
    {
      id: 'bestbuy',
      name: `Best Buy`,
      link: 'https://www.bestbuy.com/site/skylight-10-wifi-digital-picture-frame-black/6580095.p?skuId=6580095',
      image: bestBuy,
      products: ['Frame'],
    },
    {
      id: 'sams',
      name: `Sam's Club`,
      link: 'https://www.samsclub.com/p/skylight-calendar-15-inch-wifi-digital-calendar/P03021970?xid=plp_product_2',
      image: sams,
      products: ['Calendar'],
    },
    {
      id: 'amazon',
      name: `Amazon`,
      link: 'https://www.amazon.com/Skylight-Frame-Digital-Picture-Anywhere/dp/B01N7ENHO6?maas=maas_adg_6A193DE8C511CBE09C6CC52D32845E1E_afap_abs&ref_=aa_maas&tag=maas',
      image: amazon,
      products: ['Frame'],
    },
    {
      id: 'amazon',
      name: `Amazon`,
      link: 'https://www.amazon.com/Skylight-Calendar-Touchscreen-Interactive-Schedules/dp/B0C9V811L6?maas=maas_adg_16B76AF3EC9714D34FE1E6F753F7A2A5_afap_abs&ref_=aa_maas&tag=maas',
      image: amazon,
      products: ['Calendar'],
    },
    {
      id: 'walmart',
      name: `Walmart`,
      link: 'https://www.walmart.com/ip/Skylight-15-Inch-All-In-One-Touchscreen-Family-Calendar-and-Chore-Chart/15961508999?classType=REGULAR&athbdg=L1100&from=/search',
      image: walmart,
      products: ['Calendar'],
    },
  ]
  const filteredPartners = partners.filter((partner) => partner.products.includes(selectedCategory))

  const handleSelectionChange = (category) => {
    setSelectedCategory(category)
  }
  return (
    <>
      <Selection
        selected={selectedCategory === 'Frame'}
        onClick={() => handleSelectionChange('Frame')}
      >
        Frame
      </Selection>
      <Selection
        selected={selectedCategory === 'Calendar'}
        onClick={() => handleSelectionChange('Calendar')}
      >
        Calendar
      </Selection>
      <LogoContainer>
        {filteredPartners.map((partner) => (
          <a href={partner.link} target="_blank" rel="noopener noreferrer">
            <Card key={partner.id}>
              <img id={partner.id} src={partner.image} alt={partner.name} />
            </Card>
          </a>
        ))}
      </LogoContainer>
    </>
  )
}

export default RetailPartners
